import type { RouteObject } from "react-router";
import { Component } from "./utils";

export const frontendDashboardRoutes: RouteObject[] = [
    // AI Humanizer Admin Panel Routes
    { path: "dashboard", element: Component("/pages/dashboard") },
    { path: "users", element: Component("/pages/users") },
    { path: "orders", element: Component("/pages/orders") },
    { path: "stripe/transactions", element: Component("/pages/stripe/transactions") },
    { path: "stripe/customers", element: Component("/pages/stripe/customers") },
    { path: "logs/requests", element: Component("/pages/management/logs") },
    { path: "logs/dashboard", element: Component("/pages/management/logs/dashboard") },
    { path: "logs/emails", element: Component("/pages/management/logs/emails") },
    { path: "logs/requests/:id", element: Component("/pages/management/logs/detail") },
    { path: "subscriptions", element: Component("/pages/subscriptions") },
    { path: "generations", element: Component("/pages/generations") },
    { path: "resource", element: Component("/pages/resource") },
    { path: "checkin", element: Component("/pages/checkin") },
    { path: "blog", element: Component("/pages/blog") },
    { path: "blog/editor", element: Component("/pages/blog/editor") },
    { path: "blog/editor/:id", element: Component("/pages/blog/editor") },
    { path: "activities", element: Component("/pages/management/activities") },
    { path: "activities/logs", element: Component("/pages/management/activities/activity-logs") },
    { path: "writing/documents", element: Component("/pages/management/writing-agent") },
    // Pricing management route unified path '/pricing'
    { path: "pricing", element: Component("/pages/management/pricing") },
    // Sitemap management entry
    { path: "site/sitemap", element: Component("/pages/management/sitemap") },
    // Changelog management
    { path: "changelog", element: Component("/pages/management/changelog") },
    // Roulette logs management
    { path: "roulette/logs", element: Component("/pages/management/roulette") },
    // Maintenance page management
    { path: "maintenance", element: Component("/pages/management/maintenance") },
    // Support tickets management
    { path: "support", element: Component("/pages/support") },
];
